/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fileName: NonNullable<unknown> }} Errors_Uploadfailedwithfile3Inputs */

const en_errors_uploadfailedwithfile3 = /** @type {(inputs: Errors_Uploadfailedwithfile3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to upload ${i?.fileName}`)
};

/**
* | output |
* | --- |
* | "Failed to upload {fileName}" |
*
* @param {Errors_Uploadfailedwithfile3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const errors_uploadfailedwithfile3 = /** @type {((inputs: Errors_Uploadfailedwithfile3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errors_Uploadfailedwithfile3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_errors_uploadfailedwithfile3(inputs)
});
export { errors_uploadfailedwithfile3 as "errors_uploadFailedWithFile" }